import api from '@/api'

const SET_EMPLOYEES = 'SET_EMPLOYEES'
const UPDATE_ITEM = 'UPDATE_ITEM'
const REMOVE_ITEM = 'REMOVE_ITEM'

export default {
  namespaced: true,

  state () {
    return {
      items: []
    }
  },

  getters: {
    employees: (state) => state.items
  },

  mutations: {
    [SET_EMPLOYEES] (state, data) {
      state.items = data
    },

    [UPDATE_ITEM] (state, data) {
      const index = state.items
        .findIndex(item => item.id === data.id)
      if (index !== -1) {
        for (const field in data) {
          state.items[index][field] = data[field]
        }
      }
    },

    [REMOVE_ITEM] (state, data) {
      const index = state.items
        .findIndex(item => item.id === data.id)
      state.items.splice(index, 1)
    }
  },

  actions: {
    async loadEmployees ({ commit }) {
      const { data } = await api.employees.list()
      commit(SET_EMPLOYEES, data)
    },

    async createEmployee ({ dispatch }, payload) {
      const { errors } = await api.employees.create(payload)
      if (!errors) dispatch('loadEmployees')
      return { errors }
    },

    async saveEmployee ({ commit }, item) {
      const { data, errors } = await api.employees.updateById(item.id, item)
      if (!errors) {
        commit(UPDATE_ITEM, data)
      }
      return { data, errors }
    },

    async deleteEmployee ({ commit }, item) {
      const { error } = await api.employees.deleteById(item.id)
      if (!error) {
        commit(REMOVE_ITEM, item)
      }
    }
  }
}
